import request from '@/utils/request'
import qs from 'qs'
// 产品列表
export function getProductList(params) {
    //去掉params中value为空的参数
    // handleParams(params)

    return request({
        url: 'cus/getXcProduct' + "?" + qs.stringify(params, { indices: false }),
        method: 'get'
    })
}
// 获取产品详情
export function getXcProductDetail(id) {
    return request({
        url: 'cus/getXcProductDetail/' + id,
        method: 'get'
    })
}

// 获取产品动态
export function getXcProductNews(id) {
    return request({
        url: 'cus/getXcProductNews/' + id,
        method: 'get'
    })
}

// 获取全部产品动态
export function getAllXcProductNews() {
    return request({
        url: 'cus/getAllXcProductNews',
        method: 'get'
    })
}

// 获取时效码
export function getMcode(time) {
    return request({
        url: 'api/getMcode/' + time,
        method: 'get'
    })
}

export function getPoster(productId, minutes) {
    return request({
        url: 'api/getPoster/' + productId + "/" + minutes,
        method: 'get'
    })
}

function handleParams(params) {
    Object.entries(params).filter(item => { if (!params[item[0]]) delete params[item[0]] })
}
// 通过产品id获取产品信息
export function getXcProduct(id) {
    return request({
        url: 'cus/getXcProduct/' + id,
        method: 'Get'
    })
}
// 通过产品id获取产品可进件地区
export function getXcAreaConfig(id) {
    return request({
        url: 'cus/xcProductArea/' + id,
        method: 'Get'
    })
}
// 获取产品名称
export function xcProductDict() {
    return request({
        url: 'api/xcProductDict',
        method: 'Get'
    })
}
export function getProductPoster(msg) {
    return request({
        url: 'api/getProductPost',
        data: msg,
        method: 'post'
    })
}

// 获取库里已有企业名称
export function getEnterpriseName(name) {
    return request({
        url: 'cus/getEnterpriseName?enterpriseName=' + name,
        method: 'get',
    })
}

// 筛选产品
export function productFilter(data) {
    return request({
        url: 'api/productFilter',
        method: 'post',
        data
    })
}

// 获取产品海报
export function getBanner() {
    return request({
        url: 'cus/getBanner',
        method: 'get',
    })
}

// 获取企业报告海报
export function genCompanyRepoPost() {
    return request({
        url: 'api/genCompanyRepoPost',
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/api/product.js